/**
 * Converts plain text to a simplified Lexical JSON string.
 */
export const toLexicalJSON = (text: string): string => {
    return JSON.stringify({
        root: {
            children: [
                {
                    children: [{ text, type: 'text', version: 1 }],
                    type: 'paragraph',
                    version: 1,
                },
            ],
            type: 'root',
            version: 1,
        },
    });
};

/**
 * Attempts to extract plain text from a Lexical JSON string.
 * Returns the original string if parsing fails or if it's not JSON.
 */
export const fromLexicalJSON = (lexicalString: string): string => {
    try {
        const parsed = JSON.parse(lexicalString);
        const firstTextNode = parsed.root?.children?.[0]?.children?.[0];
        if (firstTextNode && typeof firstTextNode.text === 'string') {
            return firstTextNode.text;
        }

        // Valid lexical JSON but no text content should map to empty string.
        if (parsed.root) return '';
    } catch (e) {
        // Not JSON, return as is
    }
    return lexicalString;
};
